@if (scrollBarsVisible) {
  <div class="fab">
    <button mat-icon-button>
      <mat-icon (click)="scrollUp()">keyboard_arrow_up</mat-icon>
    </button>
  </div>
}